// @ts-ignore
// @ts-nocheck
import { useNavigate } from 'react-router-dom'
import { Container, GifBox, PageSubtitle, PageTitle } from './styles'
import { DashboardhMediumButton } from 'bd-web-components'
import { ReactElement, useEffect, useState } from 'react'
import { SECONDARY_BLUE_01 } from 'bd-web-components/src/utils/dash-colors'
import Lottie from 'react-lottie'
import * as animationData from '../../assets/page404.json'
import * as generalAnimationData from '../../assets/general-error.json'
import { useLocation } from 'react-router-dom'

export function Page404(): ReactElement {
  const [message, setMessage] = useState<string>(
    'Esta página que você procura não foi encontrada.'
  )
  const [tittle, setTittle] = useState<string>('Ops!')
  const [animation, setAnimation] = useState<any>(animationData)
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state as { message: string; tittle: string }

  const handlerNavigate = (url: string) => {
    navigate(url)
  }

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  useEffect(() => {
    if (state !== null) {
      setMessage(state.message)
      setTittle(state.tittle)
      setAnimation(generalAnimationData)
    }
  }, [state])

  return (
    <Container>
      <GifBox>
        <Lottie options={defaultOptions} isStopped={false} isPaused={true} />
      </GifBox>
      <PageTitle>{tittle}</PageTitle>
      <PageSubtitle>{message}</PageSubtitle>
      <DashboardhMediumButton
        onClick={() => handlerNavigate('/')}
        color="#fff"
        background={SECONDARY_BLUE_01}
        height="48px"
        maxWidth="100%"
        variant="contained"
        width="204px"
      >
        {'Voltar para início'}
      </DashboardhMediumButton>
    </Container>
  )
}
